(function(){
	var lastPosition, scroll, productHeight, originalY, startTop, bufferA, bufferB, animateA, firstStop, secondStop, aIsHidden;
  var product = $('#the-product');

  // Detect css transform
	var cssTransform = (function(){
    var prefixes = 'transform webkitTransform mozTransform oTransform msTransform'.split(' '),
        el = document.createElement('div'),
        cssTransform,
        i = 0;
    while( cssTransform === undefined ){ 
      cssTransform = document.createElement('div').style[prefixes[i]] != undefined ? prefixes[i] : undefined;
      i++;
    }
    return cssTransform;
	})();

  // recalculate positions
  function sizes() {
    productHeight = product.height();
    originalY = product.offset().top - productHeight;
    // console.log('original y: ' + originalY)
    firstStop = $('#product-stop-a').offset().top - productHeight + startTop + bufferA;
    secondStop = $('#product-stop-b').offset().top - (productHeight*2) + startTop + bufferB;
  }

  // transform function
  function setTop(m, t){
    if (cssTransform) {
      m.css(cssTransform, "translateY("+ t +"px)");
    } else {
      m.css("top", t);
    }
	}

  // animate directions section steps one-by-one
  function animateSteps() {
    if (!$('#steps').hasClass('showing')) {
      $('#steps li').each(function(index) {
        $(this).delay(800*index).queue(function(next) {
          $(this).addClass('visible');
          next();
        });
      });
      $('#steps').addClass('showing');
    }
  }

  function loop(){
    // Avoid calculations if not needed
    if (lastPosition == window.pageYOffset) {
      scroll(loop);
      return false;
    } else {
      lastPosition = window.pageYOffset;
      // console.log('==' + lastPosition);
    }
    aIsHidden = animateA.hasClass('hidden');
    // move packette from behind box
    if (lastPosition <= originalY + startTop) {
      setTop(product, startTop);
    } else {
      // stop at the cup & animate steps
      if (lastPosition >= secondStop) {
        setTop(product, secondStop - originalY);
        secondStopImg.addClass('visible');
        animateSteps(); 
      // scroll packette with page scroll        
      } else {
        setTop(product, lastPosition - originalY);
        // hide glass when scrolling back up
        if (lastPosition < secondStop) {
          secondStopImg.removeClass('visible');
        }
      }
      // show hidden list in first section after hero
      if (lastPosition >= firstStop && aIsHidden) {
        animateA.removeClass('hidden');
      }
    }
     // Recall the loop
    scroll( loop );
  }

  function initiate() {
    if (window.innerWidth > 959) {
      $('html, body').animate({scrollTop: 0}, function() {
        sizes();
        loop();
      });
    }
  }

  // hack to use Product Tabs app as CMS for product page content
  /* Commented under task MDL-May-3048 Remove Apps From Store(Product Tabs app)
    function productTabs() {
    var introCopyHere = $('#intro-copy');
    var benefitsCopyHere = $('#benefits-copy');
    var nutritionInfoHere = $('#nutrition-info');
    var supplementImgHere = $('.nutrition-inner');
    var product_related_articles = $('#ptab-related-articles');
    var iconClasses = ['icon-pour', 'icon-stir', 'icon-enjoy'];

    $('#ptab-intro-list ul li').each(function() {
      $(this).html('<span class="icon icon-check"></span><span>' + $(this).html() + '</span>');
    });

    $('#ptab-benefits-list ul li').each(function(i) {
      $(this).html('<span class="icon ' + iconClasses[i] + '"></span><span>' + $(this).html() + '</span>');
    });

    $('#ptab-ingredients-list ul li').each(function() {
      var img = $('<div>').append($(this).find('img').clone()).html();;
      var h3 = $('<div>').append($(this).find('h3').clone()).html();;
      var p = $('<div>').append($(this).find('p').last().clone()).html();;
      $(this).html('<span class="img-left">' + img + '</span><span class="copy-right">' + h3 + p + '</span>');
    });

    var intro_list = $('#ptab-intro-list ul').html();
    var intro_list_copy = '';
    if(typeof intro_list != 'undefined'){
      	intro_list_copy = '<ul class="animate-obj animate-a hidden">' + intro_list + '</ul>';
    }
    
    var benefits_ul = $('#ptab-benefits ul').html();
    var benefits_ul_new = '';
    
    if(typeof benefits_ul != 'undefined'){
     	benefits_ul_new = "<ul class='p-benefits-list'>" + benefits_ul + "</ul>"; 
    }
    
    var benefits_final = $('#ptab-benefits ul').html(benefits_ul_new);
    console.log(benefits_final);
    
    var introCopy = $('#ptab-intro').html() + intro_list_copy;
    var benefitsCopy = $('#ptab-benefits').html() + '<ul id="steps">' + $('#ptab-benefits-list ul').html() + '</ul>';
//     var supplementImg = $('#ptab-supplement-facts-image p').html();
//     var supplementFineprint = '';
//     var nutritionInfo = $('#ptab-ingredients').html() + $('#ptab-ingredients-list').html() + '<div class="nutrition-inner">' + supplementImg + supplementFineprint + '</div>';

//     if ($('#ptab-supplement-facts-text p').html() !== undefined) {
//       supplementFineprint = '<p class="fineprint">' + $('#ptab-supplement-facts-text p').html() + '</p>';
//     }
 
    introCopyHere.html(introCopy);
    benefitsCopyHere.html(benefitsCopy);
    //nutritionInfoHere.html(nutritionInfo);
    //supplementImgHere.html(supplementImg + supplementFineprint);
  }

  productTabs();
  */

  $('#shop-now a').on('click', function() {
    if (window.innerWidth > 959) {
      var scrollTo = $('#product-scene').offset().top;
    } else {
      var scrollTo = $('#AddToCartForm').offset().top;
    }
    $('html, body').animate({scrollTop: scrollTo}, function() {
      sizes();
      loop();
    });
  });

//   $(window).resize(function() {
//     waitForFinalEvent(function(){
//       if (window.innerWidth > 959) {
//         $('html, body').animate({scrollTop: 0}, function() {
//           $('.animate-a').addClass('hidden');
//           $('#steps li').removeClass('visible');
//           $('#steps').removeClass('showing');
//           $('#glass-stop, #the-product-mobile').removeClass('visible');
//           sizes();
//           loop();
//         });
//       }
//     }, 500, 'productScroll');
//   });

  
  // Detect request animation frame
  scroll = window.requestAnimationFrame ||
           window.webkitRequestAnimationFrame ||
           window.mozRequestAnimationFrame ||
           window.msRequestAnimationFrame ||
           window.oRequestAnimationFrame ||
           // IE Fallback, you can even fallback to onscroll
           function(callback){ window.setTimeout(callback, 1000/60);};
  animateA = $('.animate-a');
  secondStopImg = $('#glass-stop, #the-product-mobile');
  lastPosition = -1;
  startTop = 75;
  bufferA = 20;
  bufferB = 20;

  initiate();
  
  // set carousel for product page
  var owl = $('.nutrition.owl-carousel');
  owl.owlCarousel({
    dots:true,
    items:1,
    nav:true,
    loop: false,
    navText: ["<i class='icon-arrow-prev prev-arrow slick-arrow'></i>", "<i class='icon-arrow-next next-arrow slick-arrow'></i>"],
  });
    
})();